var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRefrigerators = function SvgRefrigerators(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LABELS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.77,
    y: 13.35,
    width: 320.11,
    height: 577.02,
    rx: 36,
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.05,13.35H406.82a36,36,0,0,1,36,36v505a36,36,0,0,1-36,36h39.23a36,36,0,0,0,36-36v-505A36,36,0,0,0,446.05,13.35Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.73,
    y: 171.87,
    width: 289.65,
    height: 9.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.38,
    y: 171.87,
    width: 38.87,
    height: 9.85,
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,238V234.7a4.32,4.32,0,0,1,.19-1.21,4.37,4.37,0,0,1-.19-1.21V229c0-2,1.35-3.62,3-3.62h18.53v-4.46c0-3.34-2.24-6-5-6H191.31c-2.76,0-5,2.7-5,6v24c0,3.33,2.24,6,5,6h19.85c2.76,0,5-2.7,5-6V241.6H197.63C196,241.6,194.63,240,194.63,238Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,235.9h-91a3.08,3.08,0,0,1-2.81-2.41,4.32,4.32,0,0,0-.19,1.21V238c0,2,1.35,3.62,3,3.62h91c1.66,0,3-1.62,3-3.62V234.7a4.31,4.31,0,0,0-.18-1.21A3.11,3.11,0,0,1,288.62,235.9Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.62,229c0-2-1.34-3.62-3-3.62h-91c-1.65,0-3,1.62-3,3.62v3.28a4.37,4.37,0,0,0,.19,1.21,3.08,3.08,0,0,0,2.81,2.41h91a3.11,3.11,0,0,0,2.82-2.41,4.37,4.37,0,0,0,.18-1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,122.93v-3.28a4.37,4.37,0,0,1,.19-1.21,4.3,4.3,0,0,1-.19-1.2V114c0-2,1.35-3.62,3-3.62h18.53v-4.46c0-3.33-2.24-6-5-6H191.31c-2.76,0-5,2.7-5,6v24c0,3.34,2.24,6,5,6h19.85c2.76,0,5-2.7,5-6v-3.27H197.63C196,126.56,194.63,124.93,194.63,122.93Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,120.86h-91a3.08,3.08,0,0,1-2.81-2.42,4.37,4.37,0,0,0-.19,1.21v3.28c0,2,1.35,3.63,3,3.63h91c1.66,0,3-1.63,3-3.63v-3.28a4.37,4.37,0,0,0-.18-1.21A3.1,3.1,0,0,1,288.62,120.86Z",
    fill: "#015e85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.62,114c0-2-1.34-3.62-3-3.62h-91c-1.65,0-3,1.63-3,3.62v3.29a4.3,4.3,0,0,0,.19,1.2,3.08,3.08,0,0,0,2.81,2.42h91a3.1,3.1,0,0,0,2.82-2.42,4.3,4.3,0,0,0,.18-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,135.13H345.46a2,2,0,0,1-2-1.79L337.9,81.76a2,2,0,0,1,2-2.21h51.55a2,2,0,0,1,2,1.78L399,132.91A2,2,0,0,1,397,135.13Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.23,
    cy: 78.32,
    rx: 9.4,
    ry: 10.22,
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.68,
    y: 225.03,
    width: 57.21,
    height: 57.21,
    rx: 5,
    fill: "#d6842d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.71,282.24l-33-2.09-2.72-3.9c-1.91-2.73-1.45-8.9-1.45-8.9-.19-2.91-.77-1.57-6.27-1.27a11.87,11.87,0,0,1-8.47-3.18L319.5,230a5,5,0,0,1,5-5h47.21a5,5,0,0,1,5,5v47.21A5,5,0,0,1,371.71,282.24Z",
    fill: "#fdb73e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.46,
    cy: 227.49,
    r: 9.27,
    fill: "#ef6ba0"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefrigerators, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refrigerators.0169d14e.svg";
export { ForwardRef as ReactComponent };